export const AUTH0_DOMAIN = "auth.kopjra.com";
export const AUTH0_CLIENT_ID = "Kc4E910TCP3sGVSPQ5G4suM6R6NrjbLv";
export const AUTH0_AUDIENCE = "https://api.gateway.kopjra.com"; // Since Auth0 doesn't support multiple audiences, we have a common API audience

export const BE_ENDPOINT = process.env.REACT_APP_BE_ENDPOINT;
export const CHG_ENDPOINT = process.env.REACT_APP_CHG_ENDPOINT;

export const ENV = process.env.REACT_APP_ENV;
